import { Component } from '@angular/core';

@Component({
  selector: 'app-evento-programado',
  standalone: true,
  imports: [],
  templateUrl: './evento-programado.component.html',
  styleUrl: './evento-programado.component.scss'
})
export class EventoProgramadoComponent {

}
